"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.snakecase"));

var _checkType = _interopRequireDefault(require("./lib/check-type"));

var _reducer = _interopRequireDefault(require("./lib/reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(inputObject) {
  (0, _checkType.default)(inputObject); // This errors if it isn't valid

  return (0, _reducer.default)(inputObject, _lodash.default);
};

exports.default = _default;